// @ts-generator-hash: cde45e31c63998b50227001be679196430a6c67155b44ae197d55b160bc9a279
// Generation date: 9/1/2026 3:57:56 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Domain.AuditCategory
export enum AuditCategory {
  Tasklist = 0,
  File = 1,
  Comment = 2,
  Grant = 3,
  Notification = 4,
  Admin = 5,
  User = 6,
}
